import startCase from 'lodash/startCase.js'

import {
  ENDICIA,
  PITNEY,
  PITNEY_MERCHANT,
  PITNEY_PRESORT,
  UPS,
  USPS_SHIP,
} from '../../../common/constants/ShipperNames.js'
import {shipperTypeSelector} from '../../../data/shippers.js'
import {useSelector} from '../../../store.js'

function getTrackingMessage(status) {
  if (status === 'manifest') {
    return 'Label Created'
  }

  return startCase(status)
}

export default function TrackingStatus({shippingInfo}) {
  const shipperID = shippingInfo?.carrier?.id
  const shipperType = useSelector(
    (state) => shipperTypeSelector(state, {shipperID}) || '',
  )

  if (!shipperType) {
    return null
  }
  if (
    ![
      PITNEY,
      ENDICIA,
      PITNEY_MERCHANT,
      PITNEY_PRESORT,
      USPS_SHIP,
      UPS,
    ].includes(shipperType)
  ) {
    return null
  }
  if (!shippingInfo.status) {
    return null
  }

  return (
    <li className="list__item--order-data">
      <strong className="margin-right-3">Tracking Status:</strong>
      {getTrackingMessage(shippingInfo.status)}
    </li>
  )
}
